import { I18n } from '@calendly/i18n'

// i18n-tasks-use t('publisher.billing.tiers.basic')
// i18n-tasks-use t('publisher.billing.tiers.essentials')
// i18n-tasks-use t('publisher.billing.tiers.premium')
// i18n-tasks-use t('publisher.billing.tiers.pro')
// i18n-tasks-use t('publisher.billing.tiers.professional')
// i18n-tasks-use t('publisher.billing.tiers.teams')
// i18n-tasks-use t('publisher.billing.tiers.teams_plus')
// i18n-tasks-use t('publisher.billing.tiers.enterprise')
const humanizeTier = (tier) => (I18n.t(`publisher.billing.tiers.${tier}`))

const calculateTieredPricingEstimate = (value, pricingTiers) => {
  let total = 0

  for (const pricingTier of pricingTiers) {
    const { starting, ending, amount_cents: amountCents } = pricingTier

    if (value < starting) break

    const calculatedStartingValue = starting - 1

    if (value >= ending) total += ((ending - calculatedStartingValue) * amountCents)
    else if (value < ending) total += ((value - calculatedStartingValue) * amountCents)
    else if (value === starting) total += (value * amountCents)
    else if (value > starting && !ending) total += ((value - calculatedStartingValue) * amountCents)
  }

  return total
}

export const helpers = {
  calculateTieredPricingEstimate,
  humanizeTier
}
